import { create } from 'zustand'

interface NavbarStore {
  isNavbarVisible: boolean
  actions: {
    setNavbarVisible: (visible: boolean) => void
  }
}

const useNavbarStoreBase = create<NavbarStore>((set) => ({
  isNavbarVisible: true,
  actions: {
    setNavbarVisible: (visible: boolean) => set({ isNavbarVisible: visible }),
  },
}))

export const useNavbarVisible = () =>
  useNavbarStoreBase((state) => state.isNavbarVisible)

export const useNavbarActions = () =>
  useNavbarStoreBase((state) => state.actions)
